import type { FighterId } from "./game-types";

export interface RosterFighter {
  id: FighterId;
  name: string;
  number: string;
  title: string;
  role: string;
  accent: string;
  portrait: string | null;
  available: boolean;
}

export const ROSTER: readonly RosterFighter[] = [
  {
    id: "dog",
    name: "DOG",
    number: "01",
    title: "THE YARDSTICK",
    role: "BALANCED ALL-ROUNDER",
    accent: "#3ff6e5",
    portrait: "/assets/fighters/states/dog-idle-v1.webp",
    available: true,
  },
  {
    id: "cat",
    name: "CAT",
    number: "02",
    title: "THE LANDER",
    role: "FAST-FALL RUSHDOWN",
    accent: "#d76cff",
    portrait: "/assets/fighters/states/cat-idle-v1.webp",
    available: true,
  },
  {
    id: "tiger",
    name: "TIGER",
    number: "03",
    title: "THE AMBUSH",
    role: "LOW-TRACTION AMBUSHER",
    accent: "#ff9f3c",
    portrait: "/assets/fighters/states/tiger-idle-v1.webp",
    available: true,
  },
  {
    id: "dolphin",
    name: "DOLPHIN",
    number: "04",
    title: "THE TIDE",
    role: "MULTI-JUMP FLOATY",
    accent: "#51d9ff",
    portrait: "/assets/fighters/states/dolphin-idle-v1.webp",
    available: true,
  },
  {
    id: "horse",
    name: "HORSE",
    number: "05",
    title: "THE STAMPEDE",
    role: "GROUND-SPEED BRUISER",
    accent: "#e9a64f",
    portrait: "/assets/fighters/states/horse-idle-v1.webp",
    available: true,
  },
  {
    id: "lion",
    name: "LION",
    number: "06",
    title: "THE CROWN",
    role: "THROW-POWER TRICKSTER",
    accent: "#ffbd42",
    portrait: "/assets/fighters/states/lion-idle-v1.webp",
    available: true,
  },
  {
    id: "elephant",
    name: "ELEPHANT",
    number: "07",
    title: "THE MOUNTAIN",
    role: "SUPER-HEAVY POWERHOUSE",
    accent: "#65c4d0",
    portrait: "/assets/fighters/states/elephant-idle-v1.webp",
    available: true,
  },
  {
    id: "otter",
    name: "OTTER",
    number: "08",
    title: "THE UNSINKABLE",
    role: "BUOYANT HEAVYWEIGHT ZONER",
    accent: "#b69aff",
    portrait: "/assets/fighters/states/otter-idle-v1.webp",
    available: true,
  },
  {
    id: "penguin",
    name: "PENGUIN",
    number: "09",
    title: "THE FLOE",
    role: "MULTI-JUMP FLOATER",
    accent: "#74e8ff",
    portrait: "/assets/fighters/states/penguin-idle-v1.webp",
    available: true,
  },
  {
    id: "wolf",
    name: "WOLF",
    number: "10",
    title: "THE COMMITTED",
    role: "ARMOURED AIR HUNTER",
    accent: "#8ea7ff",
    portrait: "/assets/fighters/states/wolf-idle-v1.webp",
    available: true,
  },
  {
    id: "squirrel",
    name: "SQUIRREL",
    number: "11",
    title: "THE BLUR",
    role: "TINY SPEEDSTER",
    accent: "#ffad51",
    portrait: "/assets/fighters/states/squirrel-special-v1.webp",
    available: true,
  },
  {
    id: "trex",
    name: "T-REX",
    number: "12",
    title: "THE EXTINCTION",
    role: "DISJOINTED BRUISER",
    accent: "#d9ad57",
    portrait: "/assets/fighters/states/trex-idle-v1.webp",
    available: true,
  },
] as const;

export const AVAILABLE_FIGHTERS = ROSTER.filter(
  (fighter): fighter is RosterFighter & { id: FighterId; available: true } =>
    fighter.available,
);

const DEFAULT_RIVALS: Record<FighterId, FighterId> = {
  dog: "tiger",
  tiger: "dog",
  cat: "wolf",
  wolf: "cat",
  dolphin: "penguin",
  penguin: "dolphin",
  horse: "lion",
  lion: "horse",
  elephant: "trex",
  trex: "elephant",
  otter: "squirrel",
  squirrel: "otter",
};

export function isPlayableFighter(
  fighter: RosterFighter,
): fighter is RosterFighter & { id: FighterId; available: true } {
  return fighter.available;
}

export function getRosterFighter(id: RosterFighter["id"]): RosterFighter {
  const fighter = ROSTER.find((entry) => entry.id === id);
  if (!fighter) {
    throw new Error(`Unknown roster fighter: ${id}`);
  }
  return fighter;
}

export function getDefaultRival(id: FighterId): FighterId {
  return DEFAULT_RIVALS[id];
}
